import React, { MouseEventHandler } from "react";
import { ReactComponent as AbsenceIcon } from "../../../icons/absence-icon.svg";
import { ReactComponent as AddBlue } from "../../../icons/add-icon.svg";
import { ReactComponent as AddUserIcon } from "../../../icons/add-user-icon.svg";
import { ReactComponent as Ai } from "../../../icons/ai-icon.svg";
import { ReactComponent as BlackFlagIcon } from "../../../icons/black-flag.svg";
import { ReactComponent as BlueCheck } from "../../../icons/blue-check.svg";
import { ReactComponent as BriefCaseAsh } from "../../../icons/briefcase-ash.svg";
import { ReactComponent as BriefCaseGreen } from "../../../icons/briefcase-green.svg";
import { ReactComponent as CertificateGreenIcon } from "../../../icons/certificate-green-icon.svg";
import { ReactComponent as ChartIcon } from "../../../icons/chart-icon.svg";
import { ReactComponent as Chevron } from "../../../icons/chevron.svg";
import { ReactComponent as ClockAsh } from "../../../icons/clock-ash.svg";
import { ReactComponent as ClockGreen } from "../../../icons/clock-green.svg";
import { ReactComponent as ConfirmationAsh } from "../../../icons/confirmation-ash.svg";
import { ReactComponent as ConfirmationGreen } from "../../../icons/confirmation-green.svg";
import { ReactComponent as Consultant } from "../../../icons/consultant-icon.svg";
import { ReactComponent as Create } from "../../../icons/create-icon.svg";
import { ReactComponent as Cross } from "../../../icons/cross-icon.svg";
import { ReactComponent as Customer } from "../../../icons/customer-icon.svg";
import { ReactComponent as DarkCheck } from "../../../icons/dark-check-icon.svg";
import { ReactComponent as DeleteRedIcon } from "../../../icons/delete-red-icon.svg";
import { ReactComponent as DeleteWhiteIcon } from "../../../icons/delete-white-icon.svg";
import { ReactComponent as DownTrend } from "../../../icons/down-trend-icon.svg";
import { ReactComponent as DownloadWhite } from "../../../icons/download-white.svg";
import { ReactComponent as Download } from "../../../icons/download.svg";
import { ReactComponent as Dropdown } from "../../../icons/dropdown-icon.svg";
import { ReactComponent as Economy } from "../../../icons/economy-icon.svg";
import { ReactComponent as Email } from "../../../icons/email-icon.svg";
import { ReactComponent as FastForward } from "../../../icons/fastforward-icon.svg";
import { ReactComponent as FilterIcon } from "../../../icons/filter-icon.svg";
import { ReactComponent as FilterThin } from "../../../icons/filter-thin.svg";
import { ReactComponent as Flag } from "../../../icons/flag.svg";
import { ReactComponent as Gear } from "../../../icons/gear-icon.svg";
import { ReactComponent as Help } from "../../../icons/help-icon.svg";
import { ReactComponent as Hidden } from "../../../icons/hidden.svg";
import { ReactComponent as Calendar } from "../../../icons/icon-calendar.svg";
import { ReactComponent as GreenCheck } from "../../../icons/icon-green-check.svg";
import { ReactComponent as Job } from "../../../icons/job-icon.svg";
import { ReactComponent as Lightning } from "../../../icons/lightning-icon.svg";
import { ReactComponent as Mail } from "../../../icons/mail.svg";
import { ReactComponent as MenuDots } from "../../../icons/menu-dots.svg";
import { ReactComponent as More } from "../../../icons/more-icon.svg";
import { ReactComponent as Name } from "../../../icons/name-icon.svg";
import { ReactComponent as OtPCheck } from "../../../icons/otp_check.svg";
import { ReactComponent as OverviewIcon } from "../../../icons/overview-icon.svg";
import { ReactComponent as Password } from "../../../icons/password-icon.svg";
import { ReactComponent as Phone } from "../../../icons/phone-icon.svg";
import { ReactComponent as PreferenceIcon } from "../../../icons/preference.svg";
import { ReactComponent as PrintWhite } from "../../../icons/print-white.svg";
import { ReactComponent as Recruitment } from "../../../icons/recruitment-icon.svg";
import { ReactComponent as RedCross } from "../../../icons/red-cross.svg";
import { ReactComponent as Report } from "../../../icons/report-icon.svg";
import { ReactComponent as Rollback } from "../../../icons/rollback.svg";
import { ReactComponent as Search } from "../../../icons/search-icon.svg";
import { ReactComponent as SearchThin } from "../../../icons/search-thin.svg";
import { ReactComponent as SmsIcon } from "../../../icons/sms-icon.svg";
import { ReactComponent as StarSparkle } from "../../../icons/starsparkle-icon.svg";
import { ReactComponent as SwedenFlag } from "../../../icons/sweden_flag.svg";
import { ReactComponent as Time } from "../../../icons/time-icon.svg";
import { ReactComponent as Visible } from "../../../icons/visible-icon.svg";
import { ReactComponent as WhiteCheck } from "../../../icons/white-check-icon.svg";
import { ReactComponent as WhiteCross } from "../../../icons/white-cross.svg";
import { ReactComponent as WhiteFlagIcon } from "../../../icons/white-flag.svg";
import { ReactComponent as ZoomIn } from "../../../icons/zoom-in.svg";
import { ReactComponent as ZoomOut } from "../../../icons/zoom-out.svg";
import { ReactComponent as Copy } from "../../../icons/copy.svg";

export const icons = [
	"downTrend",
	"email",
	"gear",
	"name",
	"password",
	"phone",
	"search",
	"search-thin",
	"check",
	"cross",
	"calendar",
	"white-check",
	"blue-check",
	"dark-check",
	"chevron",
	"white-cross",
	"red-cross",
	"rollback",
	"download",
	"download-white",
	"dropdown",
	"job",
	"time",
	"recruitment",
	"customer",
	"more",
	"menu-dots",
	"report",
	"consultant",
	"create",
	"economy",
	"help",
	"print-white",
	"clock-ash",
	"clock-green",
	"confirmation-ash",
	"confirmation-green",
	"briefcase-ash",
	"briefcase-green",
	"mail",
	"flag",
	"hidden",
	"visible",
	"add-user",
	"calendar",
	"overview",
	"zoom-in",
	"zoom-out",
	"filter",
	"filter-thin",
	"sms",
	"preference",
	"certificate-green-icon",
	"black-flag",
	"white-flag",
	"delete-white",
	"delete-red",
	"absence",
	"otp_check",
	"swedenFlag",
	"chart",
	"addBlue",
	"lightning",
	"fastforward",
	"star-sparkle",
	"ai",
	"copy",
] as const;

export type AppIconType = typeof icons[number];

export interface AppIconProps {
	icon: AppIconType;
	size?: string;
	margin?: string;
	onClick?: MouseEventHandler<any>;
	opacity?: number;
	color?: string;
	title?: string;
	// fill?: string;
	// stroke?: string;
}

const AppIcon: React.FC<AppIconProps> = ({
	icon,
	size = "16px",
	margin = "0 6px",
	opacity = 1,
	title = icon,
	onClick,
	color,
}) => {
	const Icon = renderIcon(icon);
	return (
		<Icon
			onClick={onClick}
			title={title}
			style={{ margin, width: size, opacity, cursor: onClick ? "pointer" : "inherit" }}
			width="100%"
			height="100%"
			color={color}
			preserveAspectRatio="xMidYMid meet"
		/>
	);
};

export default AppIcon;

const renderIcon = (icon: AppIconType) => {
	switch (icon) {
		case "downTrend":
			return DownTrend;
		case "email":
			return Email;
		case "gear":
			return Gear;
		case "name":
			return Name;
		case "password":
			return Password;
		case "phone":
			return Phone;
		case "search":
			return Search;
		case "search-thin":
			return SearchThin;
		case "check":
			return GreenCheck;
		case "cross":
			return Cross;
		case "calendar":
			return Calendar;
		case "chart":
			return ChartIcon;
		case "white-check":
			return WhiteCheck;
		case "blue-check":
			return BlueCheck;
		case "dark-check":
			return DarkCheck;
		case "chevron":
			return Chevron;
		case "white-cross":
			return WhiteCross;
		case "red-cross":
			return RedCross;
		case "rollback":
			return Rollback;
		case "download":
			return Download;
		case "download-white":
			return DownloadWhite;
		case "dropdown":
			return Dropdown;
		case "job":
			return Job;
		case "time":
			return Time;
		case "recruitment":
			return Recruitment;
		case "customer":
			return Customer;
		case "economy":
			return Economy;
		case "more":
			return More;
		case "menu-dots":
			return MenuDots;
		case "consultant":
			return Consultant;
		case "report":
			return Report;
		case "create":
			return Create;
		case "help":
			return Help;
		case "print-white":
			return PrintWhite;
		case "clock-ash":
			return ClockAsh;
		case "clock-green":
			return ClockGreen;
		case "confirmation-ash":
			return ConfirmationAsh;
		case "confirmation-green":
			return ConfirmationGreen;
		case "briefcase-ash":
			return BriefCaseAsh;
		case "briefcase-green":
			return BriefCaseGreen;
		case "mail":
			return Mail;
		case "flag":
			return Flag;
		case "hidden":
			return Hidden;
		case "visible":
			return Visible;
		case "add-user":
			return AddUserIcon;
		case "overview":
			return OverviewIcon;
		case "zoom-in":
			return ZoomIn;
		case "zoom-out":
			return ZoomOut;
		case "filter":
			return FilterIcon;
		case "filter-thin":
			return FilterThin;
		case "sms":
			return SmsIcon;
		case "preference":
			return PreferenceIcon;
		case "certificate-green-icon":
			return CertificateGreenIcon;
		case "black-flag":
			return BlackFlagIcon;
		case "white-flag":
			return WhiteFlagIcon;
		case "delete-white":
			return DeleteWhiteIcon;
		case "delete-red":
			return DeleteRedIcon;
		case "absence":
			return AbsenceIcon;
		case "otp_check":
			return OtPCheck;
		case "swedenFlag":
			return SwedenFlag;
		case "addBlue":
			return AddBlue;
		case "lightning":
			return Lightning;
		case "fastforward":
			return FastForward;
		case "star-sparkle":
			return StarSparkle;
		case "ai":
			return Ai;
		case "copy":
			return Copy;
		default:
			throw new Error("Missing icon type " + icon);
	}
};
